import { render, staticRenderFns } from "./ModalImportacaoItem.vue?vue&type=template&id=231dca0c&scoped=true"
import script from "./ModalImportacaoItem.vue?vue&type=script&lang=js"
export * from "./ModalImportacaoItem.vue?vue&type=script&lang=js"
import style0 from "./ModalImportacaoItem.vue?vue&type=style&index=0&id=231dca0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231dca0c",
  null
  
)

export default component.exports